var _path, _path2, _line, _line2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHangMan2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 105,
    viewBox: "0 0 204 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1956 100.398V3.58993",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8716 2.5L147.251 2.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 15.2726,
    y2: -0.5,
    transform: "matrix(0.72423 -0.689559 0.72423 0.689559 38.8716 15.1592)",
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 89.7681,
    y1: 18.457,
    x2: 89.7681,
    y2: 4.62724,
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 102.5L202 102.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangMan2);
export default __webpack_public_path__ + "static/media/HangMan2.358291cfb638e8d2dba094490120a4e4.svg";
export { ForwardRef as ReactComponent };